// The purpose of this file: Some components in the RootsTechBanner (such as the button and the text) need to know their view type (expanded or collapsed) so that their styles can be applied correctly.
import React, { createContext, useContext, useEffect } from 'react'
import { useRootsTechBannerContext } from './RootsTechBannerProvider'

const RootsTechBannerViewContext = createContext()

export const useRootsTechBannerViewContext = () => {
  return useContext(RootsTechBannerViewContext)
}

export const viewTypes = {
  EXPANDED: 'expanded',
  COLLAPSED: 'collapsed',
}

export default function RootsTechBannerViewProvider({ viewType, children }) {
  const { registerCollapsedView, registerExpandedView } = useRootsTechBannerContext()

  useEffect(() => {
    if (viewType === viewTypes.EXPANDED) {
      registerExpandedView()
    }
    if (viewType === viewTypes.COLLAPSED) {
      registerCollapsedView()
    }
  }, [registerCollapsedView, registerExpandedView, viewType])

  return <RootsTechBannerViewContext.Provider value={viewType}>{children}</RootsTechBannerViewContext.Provider>
}
